<template>
    <b-modal
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :no-close-on-esc="true"
        centered
        size="md"
        id="editar-vaga-unidade"
        @hidden="resetModal"
        :title="`Editar Vagas da unidade ${item.unidade_nome}`"
    >
        <div v-if="showMensagem" class="alert alert-warning">
            <b>O número de vaga tem que ser maior que as vagas ocupadas.</b>
        </div>
        <load mode="table" message="Salvando" v-if="load" />
        <form
            v-else
            @submit.prevent="submit"
            class="row d-flex justify-content-end"
        >
            <form-select
                label="Natureza"
                :itens="$root.arrays.acolhimento_naturezas"
                v-model="item.natureza"
                :required="true"
            />
            <form-select
                v-model="item.publico_alvo"
                :itens="$root.arrays.acolhimento_publico_alvo"
                label="Publico-alvo"
                :required="true"
                :multiple="true"
            />
            <form-input
                type="text"
                v-model="item.desc_publico_alvo"
                label="Descrição Público-Alvo"
                v-show="mostrarDescricao"
                :required="mostrarDescricao"
            />
            <form-input
                type="number"
                v-model="item.vagas"
                label="Quantidade de vagas"
                :required="true"
                @change="verificarVagas"
            />
            <form-input
                :disabled="true"
                v-model="item.vagas_disponiveis"
                label="Quantidade de vagas Disponíveis"
            />
            <form-input
                v-model="item.vagas_ocupadas"
                label="Quantidade de vagas Ocupadas"
                :disabled="true"
            />
            <button class="btn btn-success btn-sm mx-3" type="submit">
                <i class="mdi mdi-content-save"></i>
                Salvar
            </button>
        </form>
    </b-modal>
</template>
<script>
export default {
    props: ["selected"],
    data() {
        return {
            showMensagem: false,
            unidades: {},
            item: {},
            load: false,
        };
    },
    watch: {
        selected() {
            this.selected.natureza = parseInt(this.selected.natureza);
            this.item = this.selected;
        },

        'item.publico_alvo'(novosValores) {
            // Se a opção 35 não estiver selecionada, limpa o campo de descrição
            if (!novosValores.includes(35)) {
                this.item.desc_publico_alvo = ''; // ou `null`, se preferir
            }
        },
        
    },
    computed: {
        mostrarDescricao() {
            return this.item.publico_alvo.includes(35);
        }
    },
    methods: {
        verificarVagas() {
            this.showMensagem = false;
            if (this.item.vagas < this.item.vagas_ocupadas) {
                this.showMensagem = true;
                return false;
            } else {
                this.updateVagasDisponiveis();
                return true;
            }
        },
        updateVagasDisponiveis() {
            this.item.vagas_disponiveis =
                this.item.vagas - this.item.vagas_ocupadas;
        },
        submit() {
            if (this.verificarVagas()) {
                this.load = true;
                axios
                    .post("api/dashboard/acolhimento/updateunidade", {
                        item: this.item,
                    })
                    .then((response) => {
                        this.$emit("submit");
                        this.$snack.success({
                            button: false,
                            text: "Vagas editadas com sucesso.",
                        });
                        this.load = false;
                    })
                    .finally(() => {
                        this.item = "";
                        this.$bvModal.hide("editar-vaga-unidade");
                    });
            }
        },
        resetModal() {
            this.$emit("reload");
        },
    },
};
</script>
